import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FiUser,
  FiChevronDown,
  FiBell,
  FiGlobe,
  FiSearch,
} from "react-icons/fi";

// Temporary notifications
const notifications = [
  {
    id: 1,
    type: "message",
    sender: "Jane Doe",
    preview: "Hi! I’d like to book a room for 3 nights.",
    timestamp: "2 min ago",
    link: "/admin/messages",
  },
  {
    id: 2,
    type: "inquiry",
    sender: "John Smith",
    preview: "Interested in AI integration services.",
    timestamp: "10 min ago",
    link: "/admin/messages",
  },
  {
    id: 3,
    type: "feedback",
    sender: "Maria Lopez",
    preview: "Love the new dashboard layout! 👏",
    timestamp: "1 hour ago",
    link: "/admin/messages",
  },
];

const AdminNavbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const notifRef = useRef(null);

  // Close notif dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setNotifOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const section = document.querySelector(`[data-section="${searchQuery.toLowerCase()}"]`);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="flex flex-wrap items-center justify-between gap-4 px-6 py-4 bg-neutral-900 border-b border-neutral-800 shadow-sm">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2 rounded-md transition hover:opacity-80">
        <h1 className="text-2xl font-openSans font-regular text-white tracking-tight">
          Blackbear Admin
        </h1>
      </Link>

      {/* Search */}
      <form
        onSubmit={handleSearch}
        className="flex-1 max-w-md w-full relative"
        role="search"
      >
        <FiSearch className="absolute left-3 top-3 text-gray-400" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search admin tools…"
          className="w-full bg-neutral-800 text-white border border-neutral-700 rounded-md py-2 pl-10 pr-4 focus:outline-none focus:ring-2 focus:ring-blue-600"
        />
      </form>

      {/* Right actions */}
      <div className="flex items-center space-x-6">
        {/* Language toggle */}
        <button
          className="flex items-center gap-1 text-sm text-gray-300 hover:text-white transition"
          title="Switch Language"
        >
          <FiGlobe className="text-lg" />
          <span className="hidden md:block">EN</span>
        </button>

        {/* Notifications */}
        <div className="relative" ref={notifRef}>
          <button
            className="text-gray-300 hover:text-white transition relative"
            title="Notifications"
            onClick={() => setNotifOpen(!notifOpen)}
          >
            <FiBell className="text-lg" />
            {notifications.length > 0 && (
              <>
                <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-ping" />
                <span className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-xs font-bold text-white bg-red-600 rounded-full">
                  {notifications.length}
                </span>
              </>
            )}
          </button>

          {/* Notifications Dropdown */}
          {notifOpen && (
            <div className="absolute right-0 mt-2 w-80 bg-white text-gray-800 border border-gray-200 rounded-md shadow-xl z-50">
              <div className="px-4 py-2 font-semibold border-b border-gray-100">Notifications</div>
              {notifications.map((notif) => (
                <Link
                  key={notif.id}
                  to={notif.link}
                  className="block px-4 py-3 hover:bg-gray-100 transition text-sm border-b border-gray-100"
                >
                  <div className="font-medium">{notif.sender}</div>
                  <div className="text-xs text-gray-600">{notif.preview}</div>
                  <div className="text-xs text-gray-400 mt-1">{notif.timestamp}</div>
                </Link>
              ))}
              <div className="text-center p-2 text-xs text-gray-500">
                <Link to="/admin/messages" className="hover:underline">View All Messages</Link>
              </div>
            </div>
          )}
        </div>

        {/* User Dropdown */}
        <div className="relative">
          <button
            className="flex items-center gap-2 text-sm text-white hover:text-blue-400 transition"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <FiUser className="text-lg" />
            <span className="hidden md:block">Admin</span>
            <FiChevronDown className="text-sm" />
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-xl z-50">
              <button
                className="w-full text-left text-sm text-gray-700 hover:bg-gray-100 rounded px-4 py-2"
                onClick={() => setDropdownOpen(false)}
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminNavbar;
